import { FC } from 'react';
import { Field } from 'formik';
import { useTranslation } from 'mir-utils/i18n';
import { PhoneNumberField } from './PhoneNumberField';

type Props = {
  name: string;
};

/**
 * @summary Компонент PhoneNumberField, обёрнутый в Field из Формика.
 */
export const IdecoPhoneNumberField: FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <Field
      component={PhoneNumberField}
      helperText={t('Format: “plus” (+), country code, area code and local phone number')}
      {...props}
    />
  );
};
